import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  companyDetails: null,
};

const companyUserSlice = createSlice({
  name: "companyUser",
  initialState,
  reducers: {
    fetchCompanyUsers(state, action) {
      state.loading = true;
    },
    fetchCompanyUsersSuccess(state, action) {
      state.companyDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyUsersFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = companyUserSlice;
